<template>
    <v-container fluid id="footer" class="px-6 pt-6">
        <v-row no-gutters class="mt-12">
            <v-col class="mr-5">
                <img width="200rem" src="@/assets/bns-white.png"><br>
                <v-btn class="my-2" color="white" outlined to="/kapcsolat">Vedd fel velünk a kapcsolatot!</v-btn>
            </v-col>
            <v-col cols="1">
                <div class="font-weight-bold white--text mb-5" >Aloldalak</div>
                <div
                    v-for="(n, i) in 3"
                    :key="i"
                    class="my-2"
                >
                    <router-link :to="menu[i].path" class="white--text" style="text-decoration:none;">{{menu[i].title}}</router-link></div>
                
            </v-col>
            <v-col class="mt-9">
                <div
                    v-for="(n, i) in 2"
                    :key="i"
                    class="my-2"
                >
                    <router-link :to="menu[i+3].path" class="white--text"  style="text-decoration:none;">{{menu[i+3].title}}</router-link></div>
                
            </v-col>
            <v-col>
                <div class="font-weight-bold white--text mb-5">Elérhetőségek</div>
                <v-row class="my-2">
                    <v-icon color="white" class="mx-2">mdi-phone</v-icon>
                    <a href="tel:+3614560596" class="white--text mr-7">+36-1-456-0596</a>
                </v-row>
                <v-row class="my-2">
                    <v-icon color="white" class="mx-2">mdi-email</v-icon>
                    <a href="mailto:support@bns.hu" class="white--text mr-7">office@bns.hu</a>
                </v-row>
                <v-row class="my-2">
                    <v-icon color="white" class="mx-2">mdi-map-marker-radius</v-icon>
                    <a href="https://www.google.com/maps/place/BNS+M%C3%A9rn%C3%B6kiroda+Kft./@47.4793991,19.0733306,16.04z/data=!4m9!1m2!2m1!1sbns!3m5!1s0x4741dcf93ab92cdd:0xa8aa20cdde57975!8m2!3d47.4808755!4d19.072694!15sCgNibnMiA4gBAZIBE2luZHVzdHJpYWxfZW5naW5lZXI" target="_blank" class="white--text mr-7">1094 Budapest, Ferenc tér 2.</a>
                </v-row> 
            </v-col>
            <v-col>
                <iframe src="https://snazzymaps.com/embed/366631" width="100%" height="250px" class="mt-n12" style="border:none;"></iframe>
            </v-col>
        </v-row>
        <div align="end" class="white--text">Copyright © BNS Mérnökiroda Kft. 2010.</div>
    </v-container>
</template>

<script>
export default {
    name: 'Footer',
    components:{
    },
    data(){
        return{
            menu:[
                {title: 'Főoldal', path: '/'},
                {title: 'Rólunk', path: '/rolunk'},
                {title: 'Termékek', path: '/termek'},
                {title: 'Média', path: '/media'},
                {title: 'Kapcsolat', path: '/kapcsolat'},
            ]
        }
    }
}
</script>

<style scoped>
    #footer{
        background-color: #920825;
    }
    #div{
        border-left: 2px solid white;
        height: 25px;
    }
    a{
        text-decoration: none;
    }
    a:hover{
        text-decoration: underline;
        text-decoration-color: white;
    }
</style>